<div class="handheld-toolbar">
  <div class="d-table table-layout-fixed w-100">

    <nb-menu [items]="menu"></nb-menu>
    
  </div>
</div>